exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___3GxNl{display:grid;gap:1.5rem}.index-module__wrapper___3GxNl h2{font-size:1.5rem;font-weight:400;padding:1rem;color:#707070;display:flex;justify-content:center}@media (min-width:525px){.index-module__wrapper___3GxNl{grid-template-columns:1fr 1fr}}@media (min-width:1024px){.index-module__wrapper___3GxNl{grid-template-columns:1fr 1fr 1fr}}@media (min-width:1024px){.index-module__wrapper___3GxNl.index-module__school___lxyHi{grid-template-columns:1fr 1fr 1fr 1fr}}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___3GxNl",
	"school": "index-module__school___lxyHi"
};